import Tabs from "../../../../../shared/components/Tabs";
import BankingFundsHistory from "../components/BankingFundsHistory";
import BankingFundsOverview from "../components/BankingFundsOverview";
import BankingOrderCreditCard from "../components/BankingOrderCreditCard";
import { useDrawer } from "../../../hooks/useDrawer";
import type { IDrawerContent } from "../../../interfaces/drawer.interface";
import { useDepositDrawerRoute } from "./useDepositDrawerRoute";
import WithdrawalFundsFiat from "../components/WithdrawalFundsFiat";

export function useBankingDrawerRoute() {
  const { setActiveContent } = useDrawer();
  const { showFiatBankDepositDrawer } = useDepositDrawerRoute();

  function showDetailFunds() {
    setActiveContent(buildDrawerFundsHome());
  }

  function showOrderCard() {
    setActiveContent(buildDrawerOrderCardHome());
  }

  function buildBankingFundsWithdraw(): IDrawerContent {
    return {
      title: "Withdraw Funds",
      element: (
        <WithdrawalFundsFiat
          onSubmit={() => {
            setActiveContent(buildDrawerFundsHome());
          }}
        />
      ),
      onBackPressed: () => {
        setActiveContent(buildDrawerFundsHome());
      },
    };
  }

  function createBankingFundsTabs() {
    return [
      {
        label: "Overview",
        element: (
          <BankingFundsOverview
            onWithdraw={() => {
              setActiveContent(buildBankingFundsWithdraw());
            }}
            onAddFunds={() => {
              showFiatBankDepositDrawer(() => {
                setActiveContent(buildDrawerFundsHome());
              });
            }}
          />
        ),
      },
      {
        label: "History",
        element: <BankingFundsHistory />,
      },
    ];
  }

  function buildDrawerFundsHome(): IDrawerContent {
    return {
      title: "Banking",
      element: <Tabs tabs={createBankingFundsTabs()} />,
    };
  }

  function createOrderCardsTabs() {
    return [
      {
        label: "Plastic Card",
        element: (
          <BankingOrderCreditCard cardCharge="$15" deliveryCharge="$4.5" />
        ),
      },
      {
        label: "Virtual Card",
        element: <BankingOrderCreditCard cardCharge="$4.99" />,
      },
    ];
  }

  function buildDrawerOrderCardHome(): IDrawerContent {
    return {
      title: "Cards",
      element: <Tabs tabs={createOrderCardsTabs()} />,
    };
  }

  return {
    showDetailFunds,
    showOrderCard,
  };
}
